import React from 'react';
import styles from './style.module.scss';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { useTranslation } from 'next-i18next';

export const COMPLIANCE_IMAGE_OVERLAY_TYPE = 'ComplianceImageOverlay' as const;

export default function ComplianceImageOverlay() {
  const { t } = useTranslation(Namespaces.COMMON);
  return (
    <div className={styles.component} >
      <p data-overlay-type={COMPLIANCE_IMAGE_OVERLAY_TYPE} className={styles['compliance-overlay-text']}>
        {t(LOCALE_COMMON_PATHS.LISTING_CARD_SIGN_IN_OVERLAY_TEXT, { defaultValue: 'Sign In Required' })}
      </p>
    </div>
  );
}